var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"High_evel"},[_c('el-backtop',{attrs:{"visibility-height":100}}),_c('Header'),_c('keep-alive',{attrs:{"include":"Home"}},[_c('router-view')],1),_c('div',{staticClass:"separate"}),_c('div',[_c('FooterColumns'),_c('NewFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }